import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { MsalGuard } from 'msal';
import { DashboardListingComponent } from './dashboard-listing/dashboard-listing.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'code',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'WorkflowDashboard',
    redirectTo: 'workflow-dashboard' ,
    pathMatch : 'full'
  },
  { path: 'dashboard', canActivate: [MsalGuard], loadChildren: () => import('./dashboard.module').then(m => m.DashboardModule) },
  { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
  //{path:'WorkflowDashboard/MyQueue', canActivate: [MsalGuard], loadChildren: () => import('./workflow-dashboard.module').then(m => m.WorkflowDashboardModule)}


];

@NgModule({
  declarations: [],
  imports: [
    CommonModule, RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
